import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function Analytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/analytics")
      .then((r) => setData(r.data))
      .catch(() => setData({ top_posts: [], top_tags: [], recent: [], totals: {} }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ opacity: 0.6, padding: 24 }} data-testid="analytics-loading">loading analytics…</div>;
  if (!data) return null;

  const { top_posts = [], top_tags = [], recent = [], totals = {} } = data;

  const stat = (label, v) => (
    <div style={{ border: "1px solid #ffde16", borderRadius: 8, padding: "12px 16px", background: "rgba(0,0,0,0.5)" }}>
      <div style={{ fontSize: "0.7em", opacity: 0.7, letterSpacing: 1, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: "1.6em", fontWeight: "bold", color: "#ffde16" }}>{v ?? 0}</div>
    </div>
  );

  const profileEnabled = true;
  const profileGrey = !profileEnabled;

  const profileStat = (label, value, enabled) => (
    <div style={{ border: "1px solid #ffde16", borderRadius: 8, padding: "12px 16px", background: "rgba(0,0,0,0.5)", opacity: enabled ? 1 : 0.4, pointerEvents: enabled ? "auto" : "none" }}>
      <div style={{ fontSize: "0.7em", opacity: 0.7, letterSpacing: 1, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: "1.6em", fontWeight: "bold", color: "#ffde16" }}>{enabled ? (value ?? 0) : "—"}</div>
    </div>
  );

  return (
    <div data-testid="analytics-panel">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 10, marginBottom: 20 }}>
        {stat("posts", totals.posts)}
        {stat("published", totals.published)}
        {stat("drafts", totals.drafts)}
        {stat("total views", totals.views)}
        {stat("media files", totals.media)}
        {profileStat("profile views", totals.profile_views, profileEnabled)}
        {profileStat("attempted saves / screenshots", totals.profile_save_attempts, profileEnabled)}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 16 }}>
        <div>
          <h3 className="xs-section-title" style={{ marginTop: 0 }}>top posts by views</h3>
          {top_posts.length === 0 ? <div style={{ opacity: 0.6 }}>no published posts yet.</div> : (
            <ol style={{ paddingLeft: 18, margin: 0 }}>
              {top_posts.map((p) => (
                <li key={p.id} style={{ marginBottom: 6, display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <a href={`/articles/${p.slug}`} style={{ textDecoration: "none" }}>{p.title}</a>
                  <strong style={{ color: "#ffde16" }}>{p.view_count || 0}</strong>
                </li>
              ))}
            </ol>
          )}
        </div>

        <div>
          <h3 className="xs-section-title" style={{ marginTop: 0 }}>top tags</h3>
          {top_tags.length === 0 ? <div style={{ opacity: 0.6 }}>no tags yet.</div> : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {top_tags.map((t) => (
                <span key={t.tag} className="xs-tag" style={{ color: "#ffde16", padding: "4px 10px" }}>
                  #{t.tag} <span style={{ opacity: 0.7 }}>· {t.views}v · {t.posts}p</span>
                </span>
              ))}
            </div>
          )}
        </div>

        <div style={{ gridColumn: "1 / -1" }}>
          <h3 className="xs-section-title">recent publishes</h3>
          <div style={{ fontFamily: "Courier New, monospace", fontSize: "0.85em" }}>
            {recent.length === 0 ? <div style={{ opacity: 0.6 }}>nothing published yet.</div> : (
              recent.map((p) => (
                <div key={p.id} style={{ padding: "6px 0", borderBottom: "1px dashed rgba(255,222,22,0.15)", display: "flex", gap: 12, flexWrap: "wrap" }}>
                  <span style={{ opacity: 0.7 }}>{new Date(p.published_at).toLocaleString()}</span>
                  <a href={`/articles/${p.slug}`} style={{ fontFamily: "Tahoma, sans-serif" }}>{p.title}</a>
                  <span style={{ opacity: 0.6 }}>ots={p.opentimestamps_status || "—"}</span>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
